import axios from "axios";
import { useEffect, useState } from "react";
import {
  Link,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { getEndpoint } from "../hooks/useApi";

import ArticalCard from "../components/ArticalCard";
import ArticalCardSearch from "../components/ArticalCardSearch";
import Ads from "../components/Ads";
import useCategories from "../hooks/useCategories";

import {
  Box,
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Typography,
} from "@mui/material";

import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";

import useMediaQuery from "@mui/material/useMediaQuery";

const Home = () => {
  const API_ENDPOINT = getEndpoint();
  const navigate = useNavigate();
  let { type, page } = useParams();

  const [articles, setArticles] = useState([]);
  const [meta, setMeta] = useState({});
  const [pageTitle, setPageTitle] = useState("Tous les articles");

  const [categories] = useCategories(true);

  const [searchQuery, setSearchQuery] = useState("");

  const [onSearchMode, setonSearchMode] = useState(false);

  let [searchParams, setSearchParams] = useSearchParams();

  const [nextPage, setNextPage] = useState({
    disabled: true,
    path: "",
  });
  const [previousPage, setPreviousPage] = useState({
    disabled: true,
    path: "",
  });

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const matches = useMediaQuery("(min-width:600px)");

  useEffect(() => {
    // debugger
    const q = searchParams.get("q");
    if (q && q.trim() !== "") {
      if (searchQuery !== searchParams.get("q")) {
        setSearchQuery(q.trim());
      }

      if (onSearchMode) loadArticles();
      setonSearchMode(true);
      // }
    } else {
      setonSearchMode(false);
      setSearchQuery("");
    }
  }, [searchParams]);

  // useEffect(() => {
  //     console.log('onSearchMode', onSearchMode);
  // }, [onSearchMode])

  useEffect(() => {
    if (meta.page < meta.totalPages) {
      setNextPage({
        disabled: false,
        path: `/${type}/${parseInt(meta.page) + 1}${
          searchQuery !== "" ? `?q=${searchQuery}` : ""
        }`,
      });
    } else {
      setNextPage({
        disabled: true,
        path: "",
      });
    }

    let titleText = "";

    if (searchQuery !== "") {
      titleText = `Articles en recherche '${searchQuery}'`;
    } else {
      if (parseInt(type) === 0) {
        titleText = "Tous les articles";
      } else {
        const category = categories.find((c) => c.id === parseInt(type));
        titleText = `Articles de la catégorie ${category?.title}`;
      }
    }

    if (meta.page > 1) {
      setPreviousPage({
        disabled: false,
        path: `/${type}/${parseInt(meta.page) - 1}${
          searchQuery !== "" ? `?q=${searchQuery}` : ""
        }`,
      });

      titleText += ` page numéro ${meta.page}`;
    } else {
      setPreviousPage({
        disabled: true,
        path: "",
      });
    }

    setPageTitle(titleText);
  }, [meta, categories]);

  const loadArticles = () => {
    setPageTitle(`chargement des données...`);

    let url;

    if (!onSearchMode) {
      url = `${API_ENDPOINT}/articles?category=${type || "0"}&page=${
        page || 1
      }`;
    } else {
      url = `${API_ENDPOINT}/articles/search?query=${searchQuery}&page=${
        page || 1
      }`;
    }
    axios.get(url).then((res) => {
      const articles = res.data.data;

      console.log('articles', articles);

      setMeta(res.data.meta);
      setArticles(articles);
    });
  };

  useEffect(() => {
    loadArticles();
  }, [type, page, onSearchMode]);

  const handelSearchArticles = () => {
    if (searchQuery.trim() === "") return handelCancelSearch();

    navigate(`/0/1?q=${searchQuery}`);
  };

  const handelCancelSearch = () => {
    setSearchQuery("");
    setSearchParams({});
  };

  return (
    <>
      <div>
        <Link to="/pay">
          <div className="text-pay article-mini">
            <span className="red"> S’abonner/Renouveler son abonnement - </span>
            <span>Accéder à la page des paiements sécurisés</span>
            <img
              src="data:image/svg+xml;base64,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"
              alt=""
            />
          </div>
        </Link>
      </div>
      <Ads />
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mt: 3,
          alignItems: "center",
          flexDirection: !matches ? "column-reverse" : "row",
          flexWrap: "wrap",
          gap: "20px",
        }}
      >
        <Box sx={{ textAlign: "left", marginRight: "auto" }}>
          <Typography
            variant="h2"
            sx={{ fontSize: "1.5rem", fontWeight: "bolder", textAlign: "left" }}
          >
            {pageTitle}
          </Typography>
        </Box>
        <Box sx={{}}>
          <FormControl sx={{ maxWidth: "450px" }} variant="outlined">
            <InputLabel htmlFor="search-query">
              Rechercher des articles
            </InputLabel>
            <OutlinedInput
              id="search-query"
              label="Rechercher des articles"
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              variant="outlined"
              inputProps={{
                autoComplete: "on",
              }}
              onKeyDown={(e) => {
                if (e.keyCode === 13) {
                  handelSearchArticles();
                }
              }}
              startAdornment={
                <InputAdornment position="start">
                  <IconButton
                    aria-label="cancel searching"
                    onClick={handelCancelSearch}
                    edge="start"
                  >
                    <ClearIcon />
                  </IconButton>
                </InputAdornment>
              }
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="searching"
                    onClick={handelSearchArticles}
                    edge="end"
                  >
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>
        </Box>
      </Box>
      {!onSearchMode && (
        <div className="articles-container">
          {articles &&
            articles.map((article, index) => {
              return (
                <ArticalCard
                  key={article.id}
                  date={article.publishDate}
                  title={article.title}
                  description={article.description}
                  path={article.path}
                  image={article.image}
                  largeImage={index === 0}
                />
              );
            })}
        </div>
      )}
      {onSearchMode && (
        <div className="articles-container-search">
          {articles &&
            articles.map((article, index) => {
              return (
                <ArticalCardSearch
                  key={article.id}
                  title={article.title}
                  description={article.description}
                  path={article.path}
                  date={article.publishDate}
                />
              );
            })}
        </div>
      )}

      {articles.length === 0 && (
        <Box sx={{ textAlign: "center" }}>
          <Typography variant="h5">Aucun article trouvé</Typography>
        </Box>
      )}
      {articles.length > 0 && (
        <Box sx={{ mt: 2, textAlign: "center" }}>
          <Button
            disabled={nextPage.disabled}
            onClick={() => {
              navigate(nextPage.path);
              scrollToTop();
            }}
          >
            articles précédents{` >>`}
          </Button>
          <Button
            disabled={previousPage.disabled}
            onClick={() => {
              navigate(previousPage.path);
              scrollToTop();
            }}
          >
            {`<< `}articles suivants
          </Button>
        </Box>
      )}
      {/* <ButtonGroup variant="contained" aria-label="outlined primary button group" sx={{ mt: 2 }}> */}

      {/* </ButtonGroup> */}
    </>
  );
};

export default Home;
